import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const targets = ['Mujeres que quieren ingresos extra', 'Mujeres que buscan más independencia', 'Mujeres que quieren empezar desde cero sin experiencia previa', 'Mujeres cansadas de depender de un solo ingreso'];
export function ForWhoSection() {
  return <section className="bg-beige py-16 md:py-24" data-id="element-68">
      <div className="max-w-5xl mx-auto px-4" data-id="element-69">
        <div className="bg-white rounded-3xl shadow-sm border border-cream p-8 md:p-16" data-id="element-70">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-12" data-id="element-71">
            <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4" data-id="element-72">
              ¿Para quién es IA Exprés 2026?
            </h2>
            <div className="w-24 h-1 bg-gold mx-auto rounded-full" data-id="element-73" />
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-74">
            {targets.map((target, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start gap-4 p-4 rounded-2xl bg-cream/50" data-id="element-75">
                <div className="bg-gold/20 p-1.5 rounded-full text-gold shrink-0 mt-0.5" data-id="element-76">
                  <CheckIcon className="w-5 h-5" data-id="element-77" />
                </div>
                <p className="text-navy text-lg font-medium" data-id="element-78">{target}</p>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.5
        }} className="text-center bg-navy/5 p-6 rounded-2xl border border-navy/10" data-id="element-79">
            <p className="text-navy/80 text-lg" data-id="element-80">
              <span className="font-bold text-navy" data-id="element-81">
                No necesitas experiencia.
              </span>{' '}
              No necesitas invertir en herramientas caras. Solo necesitas tu
              celular y las ganas de empezar.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}